import React from 'react';
import { useParams, Link } from 'react-router-dom';
import SEOHead from '../ui/SEOHead';
import PageHero from '../ui/PageHero';
import SidebarInfo from '../ui/SidebarInfo';
import useScrollReveal from '../../hooks/useScrollReveal';
import { SERVICES_DATA, NAV_ITEMS } from '../../data/navigation';
import s from './PageContent.module.css';

// Re-export module from ui folder — just reference it relatively
// (we'll symlink below; for now import directly)

export default function ServiceDetailPage() {
  useScrollReveal();
  const { serviceSlug } = useParams();
  const svc = SERVICES_DATA.find(x => x.slug === serviceSlug);

  const navService = NAV_ITEMS.find(n => n.label === 'Services');
  const navChild   = navService?.children?.find(c => c.path === `/services/${serviceSlug}`);
  const submenuItems = navChild?.submenu || [];

  if (!svc) return (
    <section className="section"><div className="container">
      <h2>Service not found</h2>
      <Link to="/services" className="btn btn-primary" style={{marginTop:'20px'}}>View All Services</Link>
    </div></section>
  );

  return (
    <>
      <SEOHead
        title={svc.seo?.title || svc.title}
        description={svc.seo?.description || svc.excerpt}
        keywords={svc.seo?.keywords}
        canonical={`/services/${svc.slug}`}
      />
      <PageHero
        eyebrow="Our Services"
        title={svc.title}
        subtitle={svc.excerpt}
        breadcrumbs={[{ label: 'Services', path: '/services' }, { label: svc.title }]}
        cta="Book a Consultation"
        image={svc.image}
      />

      <section className="section">
        <div className="container">
          <div className={s.pageLayout}>

            {/* ── Main content ─────────────────────────────── */}
            <div>
              {/* Sub-page links grid */}
              {submenuItems.length > 0 && (
                <div className={s.subLinks} style={{marginBottom:'32px'}}>
                  {submenuItems.map(sub => (
                    <Link key={sub.path} to={sub.path} className={s.subLink}>
                      {sub.label}
                    </Link>
                  ))}
                </div>
              )}

              {/*
               * EDITABLE CONTENT AREA
               * ─────────────────────
               * Edit the `content` field in SERVICES_DATA (navigation.js).
               * Supports any HTML: <p> <ul> <ol> <img> <h2> <h3>
               * <blockquote> <table> <strong> <a> etc.
               */}
              {svc.content ? (
                <div
                  className={s.richContent}
                  dangerouslySetInnerHTML={{ __html: svc.content }}
                />
              ) : (
                <div className={s.richContent}>
                  <h2>About {svc.title}</h2>
                  <p>{svc.description}</p>
                  <p>At Celebrity Smile Studio, our goal is to provide every patient with exceptional, personalized care. We take the time to explain every procedure and answer all your questions so you feel comfortable and informed throughout your visit.</p>
                </div>
              )}

              {/* Related services */}
              <div className={s.relatedLinks}>
                {SERVICES_DATA.filter(x => x.slug !== svc.slug).slice(0, 5).map(x => (
                  <Link key={x.slug} to={`/services/${x.slug}`} className={s.relatedChip}>
                    {x.icon} {x.title}
                  </Link>
                ))}
              </div>
            </div>

            {/* ── Sidebar ──────────────────────────────────── */}
            <div className={s.sidebar}>
              <SidebarInfo />
            </div>

          </div>
        </div>
      </section>
    </>
  );
}
